import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "./ui/switch";
import { api } from "../lib/api";

export const PromoAdminCard = () => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/payments/promo").then(({ data }) => setPromo(data)).catch(() => {});
  }, []);

  const toggle = async (active) => {
    try {
      const { data } = await api.patch("/admin/promo", { active });
      setPromo(data);
      toast.success(`Code ${data.code} is now ${active ? "live" : "off"}`);
    } catch {
      toast.error("Couldn't update the discount code");
    }
  };

  if (!promo) return null;
  return (
    <div className="mb-6 rounded-2xl bg-cg-card border border-cg-gold/40 p-6 flex items-center gap-5" data-testid="admin-promo-card">
      <div className="h-11 w-11 rounded-xl grid place-items-center bg-[rgba(242,181,68,0.12)] text-cg-gold"><Ticket className="h-5 w-5" /></div>
      <div className="flex-1">
        <p className="font-serif text-lg text-cg-textp">Launch code <span className="font-mono text-cg-gold" data-testid="admin-promo-code">{promo.code}</span></p>
        <p className="text-sm text-cg-textm" data-testid="admin-promo-details">
          {promo.percent_off}% off the first payment · used {promo.times_redeemed || 0} times · {promo.active ? "live" : "off"}
        </p>
      </div>
      <Switch checked={promo.active} onCheckedChange={toggle} data-testid="admin-promo-toggle" />
    </div>
  );
};
